import { TopBanner } from './types';

export const STORIES_LIMIT = 12;

export const MAX_TOP_BANNERS = 2;

// Static, in-code maintenance banner shown on all pages for all users.
// Currently switched off. To announce a new maintenance window, update the
// `content`, set `isVisible` to true, and change the `id` so the banner
// re-appears for users who previously closed it.
export const MAINTENANCE_TOP_BANNER: TopBanner = {
  content:
    '**Scheduled maintenance:** Our services will be temporarily unavailable on Wednesday, July 29, from 12:00 to 14:00 (MSK, UTC+3) due to planned technical work. We apologize for any inconvenience.',
  id: 'maintenance-banner-wed-29-1200-1400-msk',
  isVisible: false,
  priority: Number.MAX_SAFE_INTEGER,
  users: 'all',
};
